import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';

const Courses = () => {
    const [coursesState, setCoursesState] = useState({
      isRequested: false,
      courses: []
    });
    const appContext = useContext(AppContext);

    if (!coursesState.isRequested) {
      setCoursesState({
        isRequested: true
      });
      appContext.httpClient.get({
        path: "course",
        authRedirectPath: appContext.loginPath
      }).then(response => {
          if (response.result) {
            setCoursesState({
              isRequested: true,
              courses: response.result
            });
          }
      });
    }
  
    return (
      <div className="container mx-auto p-4">
        <div className='text-sm w-full mb-6'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Courses
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <Link to="../course/add" className="text-blue-500">
                <button className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Add Course
                </button>
            </Link>
        </div>
        <table className="table-auto w-full">
          <thead>
            <tr className='bg-ui'>
                <th className="px-4 py-2 text-left">Course</th>
                <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {coursesState.courses && coursesState.courses.map(item => (
              <tr key={item.courseId} className="border-b-1">
                <td className="px-4 py-2">{item.courseTitle}</td>
                <td className="px-4 py-2">
                  <div className="flex gap-3">
                    <Link to={`../course/edit/${item.courseId}`} className="text-kenticoblue underline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#497d04" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                    </svg>
                    </Link>
                    {/*
                    <Link to={`../course/edit/${item.courseId}`} className="text-kenticoblue underline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b12628" class="bi bi-trash-fill" viewBox="0 0 16 16">
                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"/>
                    </svg>
                    </Link>
                    <Link to={`../course/edit/${item.courseId}`} className="text-kenticoblue underline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                    </svg>
                    </Link>
                    */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
};

export default Courses;
